import type { IData } from '../model/IData'

export function addIds(data: IData) {
	for (const [personId, person] of Object.entries(data.personsById)) {
		person.id = personId
	}
	for (const [coupleId, couple] of Object.entries(data.couplesById)) {
		couple.id = coupleId
	}
}
